// @ts-nocheck
(function () {
  if (window.location.pathname !== '/pages/gh-orders') return;

  const ORDER_LINK = 'https://impalaflow.com/f/dr-fels-naturals-order-ghana-b002e0';

  const css = `
    .gh-wrap * { box-sizing: border-box; margin: 0; padding: 0; }
    .gh-wrap a { text-decoration: none; }

    /* ── HERO ── */
    .gh-hero {
      background: #faf7f2;
      padding: 64px 20px 72px;
      text-align: center;
      position: relative;
      overflow: hidden;
    }
    .gh-hero::before {
      content: '';
      position: absolute;
      top: 0; left: 0; right: 0;
      height: 4px;
      background: linear-gradient(90deg, #CE1126 33%, #FCD116 33% 66%, #006B3F 66%);
    }
    .gh-hero__inner {
      max-width: 640px;
      margin: 0 auto;
      position: relative;
    }
    .gh-flag-badge {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: #fff;
      border: 1.5px solid #e8e0d4;
      border-radius: 100px;
      padding: 6px 16px;
      font-size: 0.75rem;
      font-weight: 700;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: #888;
      margin-bottom: 24px;
    }
    .gh-hero__title {
      font-size: clamp(2rem, 6vw, 3rem);
      font-weight: 800;
      line-height: 1.15;
      color: #1a1a1a;
      margin-bottom: 18px;
      font-family: var(--font-primary--family, serif);
    }
    .gh-hero__title span {
      color: #006B3F;
    }
    .gh-hero__sub {
      font-size: 1rem;
      color: #666;
      line-height: 1.75;
      max-width: 480px;
      margin: 0 auto 36px;
    }
    .gh-btn {
      display: inline-block;
      padding: 16px 36px;
      border-radius: 100px;
      font-size: 0.95rem;
      font-weight: 800;
      letter-spacing: 0.02em;
      transition: transform 0.15s, box-shadow 0.2s;
      cursor: pointer;
      border: none;
    }
    .gh-btn--primary {
      background: #1a1a1a;
      color: #faf7f2;
      box-shadow: 0 4px 20px rgba(0,0,0,0.15);
    }
    .gh-btn--primary:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 28px rgba(0,0,0,0.2);
    }
    .gh-btn--outline {
      background: transparent;
      color: #1a1a1a;
      border: 2px solid #1a1a1a;
    }
    .gh-btn--outline:hover {
      background: #1a1a1a;
      color: #faf7f2;
      transform: translateY(-2px);
    }
    .gh-hero__note {
      margin-top: 16px;
      font-size: 0.72rem;
      color: #aaa;
      letter-spacing: 0.06em;
    }

    /* ── STEPS ── */
    .gh-steps {
      background: #fff;
      padding: 72px 20px;
    }
    .gh-steps__inner {
      max-width: 960px;
      margin: 0 auto;
      text-align: center;
    }
    .gh-eyebrow {
      font-size: 0.72rem;
      font-weight: 700;
      letter-spacing: 0.13em;
      text-transform: uppercase;
      color: #006B3F;
      margin-bottom: 10px;
      display: block;
    }
    .gh-h2 {
      font-size: clamp(1.5rem, 3.5vw, 2.1rem);
      font-weight: 800;
      color: #1a1a1a;
      margin-bottom: 48px;
      font-family: var(--font-primary--family, serif);
    }
    .gh-steps__grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
      text-align: left;
    }
    .gh-step {
      background: #faf7f2;
      border-radius: 20px;
      padding: 32px 24px;
      border: 1.5px solid #ede8e0;
      position: relative;
    }
    .gh-step__num {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background: #1a1a1a;
      color: #fff;
      font-size: 0.78rem;
      font-weight: 800;
      border-radius: 50%;
      margin-bottom: 16px;
    }
    .gh-step__name {
      font-size: 1rem;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 10px;
      line-height: 1.3;
    }
    .gh-step__desc {
      font-size: 0.84rem;
      color: #777;
      line-height: 1.65;
    }
    .gh-steps__cta { margin-top: 44px; }

    /* ── TRUST ── */
    .gh-trust {
      background: #faf7f2;
      padding: 64px 20px;
    }
    .gh-trust__inner {
      max-width: 960px;
      margin: 0 auto;
    }
    .gh-trust__grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;
    }
    .gh-trust__item {
      background: #fff;
      border-radius: 16px;
      padding: 28px 24px;
      border: 1.5px solid #ede8e0;
      display: flex;
      align-items: flex-start;
      gap: 16px;
    }
    .gh-trust__icon {
      font-size: 1.6rem;
      flex-shrink: 0;
      width: 44px;
      height: 44px;
      background: #faf7f2;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .gh-trust__text h4 {
      font-size: 0.9rem;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 4px;
    }
    .gh-trust__text p {
      font-size: 0.8rem;
      color: #888;
      line-height: 1.6;
    }

    /* ── MESSAGE ── */
    .gh-message {
      background: #fff;
      padding: 72px 20px;
      text-align: center;
      position: relative;
      overflow: hidden;
    }
    .gh-message::after {
      content: '';
      position: absolute;
      bottom: 0; left: 0; right: 0;
      height: 4px;
      background: linear-gradient(90deg, #CE1126 33%, #FCD116 33% 66%, #006B3F 66%);
    }
    .gh-message__inner {
      max-width: 580px;
      margin: 0 auto;
    }
    .gh-message__flag {
      font-size: 3rem;
      display: block;
      margin-bottom: 24px;
    }
    .gh-message__quote {
      font-size: 1.1rem;
      line-height: 1.8;
      color: #444;
      font-style: italic;
      font-family: var(--font-primary--family, serif);
      margin-bottom: 20px;
    }
    .gh-message__sig {
      font-size: 0.82rem;
      font-weight: 600;
      color: #bbb;
      letter-spacing: 0.04em;
      margin-bottom: 32px;
      display: block;
    }

    /* ── MOBILE ── */
    @media (max-width: 680px) {
      .gh-hero { padding: 56px 20px 64px; }
      .gh-steps { padding: 56px 20px; }
      .gh-steps__grid { grid-template-columns: 1fr; gap: 14px; }
      .gh-trust { padding: 48px 20px; }
      .gh-trust__grid { grid-template-columns: 1fr; }
      .gh-message { padding: 56px 20px; }
      .gh-btn { width: 100%; text-align: center; padding: 16px 24px; }
    }
  `;

  const html = `
    <div class="gh-wrap">

      <div class="gh-hero">
        <div class="gh-hero__inner">
          <div class="gh-flag-badge">🇬🇭 &nbsp;Ghana Orders</div>
          <h1 class="gh-hero__title">
            Your Wellness Journey<br><span>Starts Here</span>
          </h1>
          <p class="gh-hero__sub">
            Dr. Fel's Naturals products are now available in Ghana. Order easily through our dedicated portal and get premium supplements delivered right to your door.
          </p>
          <a href="${ORDER_LINK}" class="gh-btn gh-btn--primary" target="_blank" rel="noopener noreferrer">
            Place Your Order &rarr;
          </a>
          <p class="gh-hero__note">Secure checkout &nbsp;·&nbsp; Fast delivery &nbsp;·&nbsp; 100% authentic</p>
        </div>
      </div>

      <div class="gh-steps">
        <div class="gh-steps__inner">
          <span class="gh-eyebrow">Simple process</span>
          <h2 class="gh-h2">How to Place Your Order</h2>
          <div class="gh-steps__grid">
            <div class="gh-step">
              <div class="gh-step__num">01</div>
              <h3 class="gh-step__name">Click the Order Button</h3>
              <p class="gh-step__desc">Tap "Place Your Order" to open our secure, dedicated Ghana ordering portal — no account needed.</p>
            </div>
            <div class="gh-step">
              <div class="gh-step__num">02</div>
              <h3 class="gh-step__name">Choose Your Products</h3>
              <p class="gh-step__desc">Browse our full supplement range and select what you need. The same world-class quality, now available to you.</p>
            </div>
            <div class="gh-step">
              <div class="gh-step__num">03</div>
              <h3 class="gh-step__name">Checkout & Receive</h3>
              <p class="gh-step__desc">Pay securely and we handle the rest. Your Dr. Fel's Naturals order will be on its way to you in Ghana.</p>
            </div>
          </div>
          <div class="gh-steps__cta">
            <a href="${ORDER_LINK}" class="gh-btn gh-btn--outline" target="_blank" rel="noopener noreferrer">
              Start My Order &rarr;
            </a>
          </div>
        </div>
      </div>

      <div class="gh-trust">
        <div class="gh-trust__inner">
          <div class="gh-trust__grid">
            <div class="gh-trust__item">
              <span class="gh-trust__icon">🩺</span>
              <div class="gh-trust__text">
                <h4>Doctor-Formulated</h4>
                <p>Developed with clinical precision for real, measurable health results.</p>
              </div>
            </div>
            <div class="gh-trust__item">
              <span class="gh-trust__icon">🌍</span>
              <div class="gh-trust__text">
                <h4>Proudly Serving Ghana</h4>
                <p>Bringing premium wellness supplements to our customers across Ghana.</p>
              </div>
            </div>
            <div class="gh-trust__item">
              <span class="gh-trust__icon">✅</span>
              <div class="gh-trust__text">
                <h4>100% Authentic</h4>
                <p>Ships directly from Dr. Fel's Naturals — always genuine, never third-party.</p>
              </div>
            </div>
            <div class="gh-trust__item">
              <span class="gh-trust__icon">💬</span>
              <div class="gh-trust__text">
                <h4>Dedicated Support</h4>
                <p>Questions? Our support team is always here to help you every step of the way.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="gh-message">
        <div class="gh-message__inner">
          <span class="gh-message__flag">🇬🇭</span>
          <p class="gh-message__quote">
            "Dear valued customers in Ghana, we're excited to let you know that you can now easily place orders for our products directly in Ghana. Thank you for your continued support — we look forward to serving you on your wellness journey."
          </p>
          <span class="gh-message__sig">— Dr. Fel's Naturals Team</span>
          <a href="${ORDER_LINK}" class="gh-btn gh-btn--primary" target="_blank" rel="noopener noreferrer">
            Order Now &rarr;
          </a>
        </div>
      </div>

    </div>
  `;

  function inject() {
    const target =
      document.querySelector('.main-page') ||
      document.querySelector('[data-section-type="main-page"]') ||
      document.querySelector('main .shopify-section') ||
      document.querySelector('main');
    if (!target) return;

    const style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
    target.innerHTML = html;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
